"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return XcMigrationSourcev0;
    }
});
const _nc_001_init = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_001_init"));
const _nc_002_teams = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_002_teams"));
const _nc_003_alter_row_color_condition_nc_order_col = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_003_alter_row_color_condition_nc_order_col"));
const _nc_004_workflows = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_004_workflows"));
const _nc_005_add_user_specific_and_meta_column_in_sync_configs = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_005_add_user_specific_and_meta_column_in_sync_configs"));
const _nc_006_dependency_slots = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_006_dependency_slots"));
const _nc_007_workflow_draft = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_007_workflow_draft"));
const _nc_008_license_server = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_008_license_server"));
const _nc_009_dependency_tracker_timestamp = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_009_dependency_tracker_timestamp"));
const _nc_010_add_constraints_col_in_column_table = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_010_add_constraints_col_in_column_table"));
const _nc_011_merge_workflows_scripts = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_011_merge_workflows_scripts"));
const _nc_012_workflow_delay = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_012_workflow_delay"));
const _nc_013_composite_pk_missing_tables = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_013_composite_pk_missing_tables"));
const _nc_014_sandboxes = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_014_sandboxes"));
const _nc_015_managed_apps = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_015_managed_apps"));
const _nc_016_automation_error_notifications = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_016_automation_error_notifications"));
const _nc_017_add_canonical_email_to_users = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_017_add_canonical_email_to_users"));
const _nc_018_add_enabled_to_filter_exp_v2 = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_018_add_enabled_to_filter_exp_v2"));
const _nc_019_sandboxes = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_019_sandboxes"));
const _nc_020_add_cell_coloring_fields_to_row_color_conditions = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_020_add_cell_coloring_fields_to_row_color_conditions"));
const _nc_021_scim_support = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_021_scim_support"));
const _nc_022_record_templates = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_022_record_templates"));
const _nc_023_rls_policies = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_023_rls_policies"));
const _nc_202601010000_placeholder = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202601010000_placeholder"));
const _nc_202602250000_outline_view = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202602250000_outline_view"));
const _nc_202602250001_button_filter = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202602250001_button_filter"));
const _nc_202602260000_rename_outline_to_list_view = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202602260000_rename_outline_to_list_view"));
const _nc_202602260636_view_sections = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202602260636_view_sections"));
const _nc_202602251401_links_v2 = /*#__PURE__*/ _interop_require_wildcard(require("./v0/nc_202602251401_links_v2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let XcMigrationSourcev0 = class XcMigrationSourcev0 {
    // Must return a Promise containing a list of migrations.
    // Migrations can be whatever you want, they will be passed as
    // arguments to getMigrationName and getMigration
    getMigrations() {
        // In this run we are just returning migration names
        return Promise.resolve([
            'nc_001_init',
            'nc_002_teams',
            'nc_003_alter_row_color_condition_nc_order_col',
            'nc_004_workflows',
            'nc_005_add_user_specific_and_meta_column_in_sync_configs',
            'nc_006_dependency_slots',
            'nc_007_workflow_draft',
            'nc_008_license_server',
            'nc_009_dependency_tracker_timestamp',
            'nc_010_add_constraints_col_in_column_table',
            'nc_011_merge_workflows_scripts',
            'nc_012_workflow_delay',
            'nc_013_composite_pk_missing_tables',
            'nc_014_sandboxes',
            'nc_015_managed_apps',
            'nc_016_automation_error_notifications',
            'nc_017_add_canonical_email_to_users',
            'nc_018_add_enabled_to_filter_exp_v2',
            'nc_019_sandboxes',
            'nc_020_add_cell_coloring_fields_to_row_color_conditions',
            'nc_021_scim_support',
            'nc_022_record_templates',
            'nc_023_rls_policies',
            'nc_202601010000_placeholder',
            'nc_202602250000_outline_view',
            'nc_202602250001_button_filter',
            'nc_202602260000_rename_outline_to_list_view',
            'nc_202602260636_view_sections',
            'nc_202602251401_links_v2'
        ]);
    }
    getMigrationName(migration) {
        return migration;
    }
    getMigration(migration) {
        switch(migration){
            case 'nc_001_init':
                return _nc_001_init;
            case 'nc_002_teams':
                return _nc_002_teams;
            case 'nc_003_alter_row_color_condition_nc_order_col':
                return _nc_003_alter_row_color_condition_nc_order_col;
            case 'nc_004_workflows':
                return _nc_004_workflows;
            case 'nc_005_add_user_specific_and_meta_column_in_sync_configs':
                return _nc_005_add_user_specific_and_meta_column_in_sync_configs;
            case 'nc_006_dependency_slots':
                return _nc_006_dependency_slots;
            case 'nc_007_workflow_draft':
                return _nc_007_workflow_draft;
            case 'nc_008_license_server':
                return _nc_008_license_server;
            case 'nc_009_dependency_tracker_timestamp':
                return _nc_009_dependency_tracker_timestamp;
            case 'nc_010_add_constraints_col_in_column_table':
                return _nc_010_add_constraints_col_in_column_table;
            case 'nc_011_merge_workflows_scripts':
                return _nc_011_merge_workflows_scripts;
            case 'nc_012_workflow_delay':
                return _nc_012_workflow_delay;
            case 'nc_013_composite_pk_missing_tables':
                return _nc_013_composite_pk_missing_tables;
            case 'nc_014_sandboxes':
                return _nc_014_sandboxes;
            case 'nc_015_managed_apps':
                return _nc_015_managed_apps;
            case 'nc_016_automation_error_notifications':
                return _nc_016_automation_error_notifications;
            case 'nc_017_add_canonical_email_to_users':
                return _nc_017_add_canonical_email_to_users;
            case 'nc_018_add_enabled_to_filter_exp_v2':
                return _nc_018_add_enabled_to_filter_exp_v2;
            case 'nc_019_sandboxes':
                return _nc_019_sandboxes;
            case 'nc_020_add_cell_coloring_fields_to_row_color_conditions':
                return _nc_020_add_cell_coloring_fields_to_row_color_conditions;
            case 'nc_021_scim_support':
                return _nc_021_scim_support;
            case 'nc_022_record_templates':
                return _nc_022_record_templates;
            case 'nc_023_rls_policies':
                return _nc_023_rls_policies;
            case 'nc_202601010000_placeholder':
                return _nc_202601010000_placeholder;
            case 'nc_202602250000_outline_view':
                return _nc_202602250000_outline_view;
            case 'nc_202602250001_button_filter':
                return _nc_202602250001_button_filter;
            case 'nc_202602260000_rename_outline_to_list_view':
                return _nc_202602260000_rename_outline_to_list_view;
            case 'nc_202602260636_view_sections':
                return _nc_202602260636_view_sections;
            case 'nc_202602251401_links_v2':
                return _nc_202602251401_links_v2;
        }
    }
};
